module.exports = __webpack_public_path__ + "static/brand-cailiang-d7d481f8a2b3523054ff39723b6540ac.png";